import apiClient from '@/services/apiClient';
import {
  displayCurrencyRef,
  isSpainRef,
  visitorCountryRef,
} from '@/composables/useDisplayCurrency';

let visitRegistered = false;

function persistGeoFromResponse(data) {
  if (!data?.display_currency) return;

  displayCurrencyRef.value = data.display_currency;
  visitorCountryRef.value = data.country_code || null;
  isSpainRef.value = Boolean(data.is_spain);

  try {
    const prefix = (process.env.VUE_APP_STORAGE_PREFIX || 'godea').toLowerCase();
    if (data.country_code) {
      localStorage.setItem(`${prefix}_visitor_country`, data.country_code);
    }
    localStorage.setItem(`${prefix}_display_currency`, data.display_currency);
  } catch {
    // ignore storage errors
  }
}

export const registerVisit = async () => {
  // Verificar si ya se registró la visita en esta sesión
  if (visitRegistered) {
    return;
  }

  try {
    const response = await apiClient.post('/register-visit/');
    if (response.data && response.data.success) {
      visitRegistered = true;
      persistGeoFromResponse(response.data);
    }
  } catch (error) {
    console.error('Error al registrar visita:', error);
  }
};

// Registrar visita cuando el navegador está idle (no compite con carga inicial / carrito)
if (typeof window !== 'undefined') {
  const deferVisit = window.requestIdleCallback
    ? (cb) => window.requestIdleCallback(cb, { timeout: 5000 })
    : (cb) => setTimeout(cb, 2500);
  deferVisit(() => {
    registerVisit();
  });
}
